module.exports = __webpack_public_path__ + "Frame415-a30939bc.webp";